import { Flex, Footer as UIFooter, Grid, Icon, NewTextLogo, Span } from "..";
import { CompanyAccordion } from "./CompanyAccordion";
import { LegalAccordion } from "./LegalAccordion";
import { ImportantNoteAccordion } from "./ImportantNoteAccordion";
import { Link } from "react-router-dom";
import { ABOUT_US_URL, BLOGS_URL, DISCLOSURES_URL, FEES_URL, GETTING_STARTED_URL, route } from "../../routes";
import "./GoodFillFooter.scss";

const GOODFILL_URL = import.meta.env.VITE_GOODFILL_URL;
const PRIVACY_POLICY_LINK = import.meta.env.VITE_PRIVACY_POLICY_LINK;
const TERMS_AND_CONDITIONS_LINK = import.meta.env.VITE_INTERACTIVE_BROKERS_TERMS_LINK;

export const FooterMenuItem = (props: {
  title: string;
  href?: string;
  current?: boolean;
  children: React.ReactChild;
  target?: string;
}) => {
  const classNamesItem = "py-1";
  const classNamesAnchor = "hover:font-semibold text-white no-underline	";

  const elementProps = {
    className: classNamesAnchor,
    title: props.title,
    target: props.target,
  };

  return (
    <li className={classNamesItem}>
      {props.href !== undefined ? (
        <a
          {...elementProps}
          href={props.href}
          rel={props.target === "_blank" ? "noreferrer" : undefined}
          aria-current={props.current === true ? "page" : undefined}
        >
          {props.title}
        </a>
      ) : (
        <span {...elementProps}>{props.title}</span>
      )}
    </li>
  );
};
export const GoodfillFooter = () => {
  const classNamesHeaders = "text-xl font-semibold mb-6";

  return (
    <UIFooter
      bottom={
        <>
          {/* show only on small screen */}
          <div className="show-none-before-md font-poppins font-base">
            <a href="/">
              <NewTextLogo />
            </a>
            <p className="text-white py-10">
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis
              enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
            </p>
            <CompanyAccordion />
            <LegalAccordion />
            <ImportantNoteAccordion />
            <Flex gap={2}>
              <Span className="GoodFillFooter_socialMediaIconFooter">
                <Icon name="facebook" />
              </Span>
              <Span className="GoodFillFooter_socialMediaIconFooter">
                <Icon name="twitter" />
              </Span>
              <Span className="GoodFillFooter_socialMediaIconFooter">
                <Icon name="linkedIn" />
              </Span>
            </Flex>
            <hr className="text-white mt-16 mb-6" style={{ border: "0.5px solid rgba(255, 255, 255, 0.5)" }} />
            <p className="copyright text-white text-center">© 2000-2022, All Rights Reserved</p>
          </div>
          {/* show only on large screen */}
          <div className="font-poppins font-base show-none-after-md">
            <Grid cols="grid-cols-3">
              <Flex direction="col" justify="between">
                <a href="/">
                  <NewTextLogo />
                </a>
                <Flex gap={2}>
                  <Span className="GoodFillFooter_socialMediaIconFooter">
                    <Icon name="facebook" />
                  </Span>
                  <Span className="GoodFillFooter_socialMediaIconFooter">
                    <Icon name="twitter" />
                  </Span>
                  <Span className="GoodFillFooter_socialMediaIconFooter">
                    <Icon name="linkedIn" />
                  </Span>
                </Flex>
              </Flex>
              <>
                <Flex justify="around">
                  <nav className="text-white">
                    <h3 className={classNamesHeaders}>Company</h3>
                    <ul>
                      <FooterMenuItem title="GoodFill" href={GOODFILL_URL} current>
                        GoodFill
                      </FooterMenuItem>
                      <FooterMenuItem title="About Us" href={ABOUT_US_URL}>
                        About Us
                      </FooterMenuItem>
                      <FooterMenuItem title="Getting Started" href={GETTING_STARTED_URL}>
                        Getting Started
                      </FooterMenuItem>
                      <FooterMenuItem title="Fees" href={FEES_URL}>
                        Fees
                      </FooterMenuItem>
                      <Link to={route.dashboard()} target="_blank">
                        <FooterMenuItem title="Bonds">Bonds</FooterMenuItem>
                      </Link>
                      <FooterMenuItem title="Blog" href={BLOGS_URL}>
                        Blog
                      </FooterMenuItem>
                    </ul>
                  </nav>

                  <nav className="text-white">
                    <h3 className={classNamesHeaders}>Legal</h3>
                    <ul>
                      <FooterMenuItem title="Privacy Policy" target="_blank" href={PRIVACY_POLICY_LINK}>
                        Privacy Policy
                      </FooterMenuItem>
                      <FooterMenuItem title="Terms &amp; Conditions" target="_blank" href={TERMS_AND_CONDITIONS_LINK}>
                        Terms &#038; Conditions
                      </FooterMenuItem>
                      <FooterMenuItem title="Disclosures" href={DISCLOSURES_URL}>
                        Disclosures
                      </FooterMenuItem>
                    </ul>
                  </nav>
                </Flex>

                <Flex direction="col" className="ml-auto w-9/12">
                  <h3 className={classNamesHeaders} style={{ color: "white" }}>
                    Important Notes
                  </h3>
                  <p className="text-white text-xs">
                    All investing involves risk.
                    <br />
                    Brokerage services are offered through Goodfill USA, LLC (“GUSA”) a registered broker dealer
                    (member SIPC) and clearing services through Interactive Brokers, LLC, (“IB LLC”) a registered
                    broker dealer (member SIPC). Securities products offered by GUSA are not FDIC insured and involve
                    risk, including possible loss of principal. Keep in mind that trading commissions and, in certain
                    cases, ACH, wire transfer fees and paper statement fees may apply to your brokerage account. Please
                    see GUSA&apos;s Fee Schedule to learn more.
                  </p>
                </Flex>
              </>
            </Grid>
            <hr className="text-white mt-16 mb-6" style={{ border: "0.5px solid rgba(255, 255, 255, 0.5)" }} />
            <div className="text-white text-center text-sm flex justify-between flex">
              <p className="copyright">© 2000-2022, All Rights Reserved</p>
              <p>Website Designed & Developed By: Gooffill LLC</p>
            </div>
          </div>
        </>
      }
    />
  );
};
